<button
  *ngIf="isModerator && !isReviewed"
  nbButton
  ghost
  shape="round"
  status="primary"
  size="small"
  class="action-button"
  nbTooltip="Duyệt"
  nbTooltipPlacement="bottom"
  [disabled]="loading"
  [class.btn-pulse]="loading"
  (click)="approve(true)"
>
  <nb-icon icon="checkmark-circle-outline" status="success"></nb-icon>
</button>

<button
  *ngIf="isModerator && !isReviewed"
  nbButton
  ghost
  shape="round"
  status="primary"
  size="small"
  class="action-button"
  nbTooltip="Từ chối"
  nbTooltipPlacement="bottom"
  [disabled]="loading"
  [class.btn-pulse]="loading"
  (click)="approve(false)"
>
  <nb-icon icon="close-circle-outline" status="danger"></nb-icon>
</button>
